/* eslint-disable */
import { Providers, Msal2Provider, ProviderState } from "@microsoft/mgt";
import moment from "moment";
import { AxiosStatic, Axios } from "axios";
import { User, useUserStore } from "@/store/UserStore";
import { jwtDecode } from "jwt-decode";

// import { Buffer } from 'buffer'
// ProvidesState aparece como no definido
/* ProviderState {
    Loading -> 0,
    SignedOut -> 1,
    SignedIn -> 2
}
*/
import Buffer from "buffer";
import router from "@/router";
import { useCommonStore } from "@/store/CommonStore";
import { Proyecto } from "@/store/ProyectosStore";
import { ProductoAcabado } from "@/store/ProductosAcabadoStore";
import { Material } from "@/store/MaterialesStore";
import { TareaBBDD } from "@/store/TareasStore";
interface ProjectConfig {
  projectName: string;
  groupId: string;
  subfolders: string[];
 }
// class Msal2ProviderCustom extends Msal2Provider
// {
//   getUserRoles() {
//     try {
//       this.getActiveAccount()
//     return this.getAccount()?.idTokenClaims?.roles
//     } catch (ex) {

//     }
//   }
// }

Providers.globalProvider = new Msal2Provider({
  clientId:
    process.env.VUE_APP_CLIENTID !== undefined
      ? process.env.VUE_APP_CLIENTID
      : "",
  authority: process.env.VUE_APP_AUTHORITY,
});

class AzureService {
  axios;
  baseUrl;
  constructor(axios: AxiosStatic, apiUrl: string) {
    this.axios = axios;
    this.baseUrl = `${apiUrl}`;
  }

  configureProvider() {
    if (Providers.globalProvider) {
      this.loggedIn(Providers.globalProvider);
      Providers.globalProvider.onStateChanged(this.loggedIn);
    }
    Providers.onProviderUpdated(() => {
      if (Providers.globalProvider) {
        this.loggedIn(Providers.globalProvider);
        Providers.globalProvider.onStateChanged(this.loggedIn);
      }
    });
    return Providers.globalProvider.state;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  loggedIn(provider: any) {
    const userStore = useUserStore();
  
    if (provider.state === 2) {
      const tokenRequest = {
        scopes: [
          process.env.VUE_APP_API_SCOPE !== undefined
            ? process.env.VUE_APP_API_SCOPE
            : "",
        ],
      };
  
      Providers.globalProvider
        .getAccessToken(tokenRequest)
        .then(async (token) => {
          if (token) {
            const decoded: any = jwtDecode(token);
            const roles = decoded.roles || [];
            console.log("Roles del usuario:", roles);
  
            if (roles) {
              userStore.SetUserRoles(roles);
            }
  
            this.getGraphMe().then(() => {
              userStore.SetSignin(true);
  
              // 🔁 Redirección después del login
              const redirectPath = sessionStorage.getItem("redirectAfterLogin");
              console.log("redirectPath", redirectPath);
  
              if (redirectPath) {
                console.log("router push", redirectPath);
                router.push(redirectPath);
                sessionStorage.removeItem("redirectAfterLogin");
              } else if (
                router.currentRoute.value.path.toLowerCase().includes("login")
              ) {
                router.push({ name: "Dashboard" });
              }
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching access token:", error);
          userStore.SetSignin(false);
          router.push({ name: "Login" });
        });
    } else if (provider.state === 1) {
      userStore.SetSignin(false);
      router.push({ name: "Login" });
    }
  }
  

  async getGraphMe() {
    const userStore = useUserStore();
    await Providers.globalProvider.graph.client
      .api("me")
      .get()
      .then((response) => {
        userStore.SetCurrentUser(response);
      });
  }
  async getGraphFolderSP(folderPath:string) {
    if(process.env.VUE_APP_SP_SITEID)
    return await Providers.globalProvider.graph.client
      .api(
        `/sites/${process.env.VUE_APP_SP_SITEID}/drive/root:/${folderPath}`
      )
      .get()
      .catch((error) => {
        console.error(error)
        return null;
      })
  }
  async getGraphItemsSP(folderId: string) {
    if(process.env.VUE_APP_SP_SITEID)
    return await Providers.globalProvider.graph.client
    .api(`/sites/${process.env.VUE_APP_SP_SITEID}/drive/items/${folderId}/children`)
    .get();
  }

  async createFolderSP(folderPath: string) {
    if(process.env.VUE_APP_SP_SITEID)
    await Providers.globalProvider.graph.client
    .api(`/sites/${process.env.VUE_APP_SP_SITEID}/drive/root:/${folderPath}`)
    .put({
      folder: {},
      "@microsoft.graph.conflictBehavior": "rename",
    })
      .catch((error: any) => {
        console.error(error);
      });
  }

  async getUserById(userId:string) {
    try {
      const user = await Providers.globalProvider.graph.client
        .api(`/users/${userId}`)
        .get();
      return user;
    } catch (error) {
      console.error("Error fetching user by Id :" + userId, error);
      throw error;
    }
  }
  async updateProjectTasks(
    proyecto: Proyecto,
    prodAcabado: ProductoAcabado | null,
    material: Material | null,
    tareaCompletada: TareaBBDD | null,
    materialCambioCodigo: boolean
  ) {
    const data = JSON.stringify({
      Proyecto: proyecto,
      ProductoAcabado: prodAcabado,
      Material: material,
      TareaCompletada: tareaCompletada,
      MaterialCambioCodigo: materialCambioCodigo,
    });
    await this.axios.post(`${this.baseUrl}UpdateTasksProject`, data);
  }
  notificarTareas(
    proyecto: Proyecto,
    prodAcabado: ProductoAcabado | null,
    material: Material | null,
    tareaCompletada: TareaBBDD
  ) {
    const data = JSON.stringify({
      Proyecto: proyecto,
      ProductoAcabado: prodAcabado,
      Material: material,
      TareaCompletada: tareaCompletada,
      MaterialCambioCodigo: false,
    });
    this.axios.post(`${this.baseUrl}NotificarTareas`, data);
  }

  deleteProjectTaks(id: number, tipoTarea: string) {
    this.axios.post(
      `${this.baseUrl}DeleteProjectTasks?id=${id}&TipoTarea=${tipoTarea}`
    );
  }
}
export default AzureService;
